import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/app/StatusBadge";
import { api, formatApiError } from "@/lib/api";
import { useApp } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";

export const ChangePassword = () => {
  const { L } = useApp();
  const { user, refresh } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const has = user.has_password;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password !== f.confirm) return toast.error(L("Pengesahan kata laluan tidak sepadan.", "Passwords do not match."));
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: has ? f.current_password : null, new_password: f.new_password });
      toast.success(has ? L("Kata laluan ditukar", "Password changed") : L("Kata laluan ditetapkan. Anda kini boleh log masuk dengan emel.", "Password set. You can now log in with email."));
      setF({ current_password: "", new_password: "", confirm: "" });
      refresh();
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  const field = (k, label, testId, auto) => (
    <div className="space-y-1.5"><Label htmlFor={k}>{label}</Label><Input id={k} type="password" required minLength={k === "current_password" ? 1 : 8} autoComplete={auto} value={f[k]} onChange={set(k)} className="h-10 rounded-xl" data-testid={testId} /></div>
  );
  return (
    <Card className="mt-6 p-6" data-testid="change-password-card">
      <h2 className="font-semibold">{has ? L("Tukar kata laluan", "Change password") : L("Tetapkan kata laluan", "Set a password")}</h2>
      <p className="mt-1 text-sm text-slate-500">{has ? L("Sekurang-kurangnya 8 aksara.", "At least 8 characters.") : L("Akaun anda menggunakan log masuk Google. Tetapkan kata laluan untuk turut log masuk dengan emel.", "Your account uses Google sign-in. Set a password to also log in with email.")}</p>
      <form onSubmit={submit} className="mt-4 grid gap-4 sm:grid-cols-3">
        {has && field("current_password", L("Kata laluan semasa", "Current password"), "current-password-input", "current-password")}
        {field("new_password", L("Kata laluan baharu", "New password"), "new-password-input", "new-password")}
        {field("confirm", L("Sahkan kata laluan baharu", "Confirm new password"), "confirm-password-input", "new-password")}
        <div className="sm:col-span-3"><Button type="submit" disabled={busy} className="rounded-xl bg-violet-600 hover:bg-violet-700" data-testid="change-password-btn">{has ? L("Tukar kata laluan", "Change password") : L("Tetapkan kata laluan", "Set password")}</Button></div>
      </form>
    </Card>
  );
};
